import { z } from 'zod'

/** Button variants available. */
export const VariantButton = z.enum([
    'contained',
    'icon',
    'link',
    'outlined',
    'text',
])
export type VariantButton = z.infer<typeof VariantButton>

/** Button colors available. */
export const ColorButton = z.enum([
    'error',
    'grey',
    'primary',
    'secondary',
    'success',
])

export type ColorButton = z.infer<typeof ColorButton>

/** Button size available. */
export const SizeButton = z.enum(['small', 'medium', 'large'])
export type SizeButton = z.infer<typeof SizeButton>
